export default "__VITE_ASSET__DAXvI0Ge__"